export const pkgLabels: string[] = [
    'user_num',
    'channel_num',
    'plugin_num',
    'email_num',
    'page_num',
    'instagram_num',
    'telegram_num',
    'line_num',
    'whatsapp_num',
    'work_weixin_num',
    'slack_num',
    'vkontakte_num',
    'tiktok_business_num',
    'work_weixin_bot_num',
    'youtube_num',
    'wechat_num',
    'port_num',
    'whatsapp_app_port_num',
    'telegram_app_port_num',
    'tiktok_app_port_num',
    'zalo_app_port_num',
    'line_app_port_num',
    // 'session_num',
    'faq_num',
    'monthly_active_user_num',
    // 'auto_reply_num',
    // 'ai_reply_num',
    'translate_num',
    'broadcast_plan_num',
    'free_translate_num',
    'send_email_num',
];

export const pkgDetailsV1: string[] = [
    'user_num',
    'plugin_num',
    'email_num',
    'page_num',
    'instagram_num',
    'telegram_num',
    'line_num',
    'whatsapp_num',
    'slack_num',
    'label_num',
    // 'auto_reply_num',
    'flow_num',
    'monthly_active_user_num',
    // 'ai_reply_num',
    'faq_num',
    'translate_num',
    'send_email_num',
];

export const pkgDetails: string[] = [
    'expand_user_num',
    'expand_channel_num',
    'expand_port_num',
    'basic_user_num',
    'basic_channel_num',
    'basic_port_num',
    'free_channel_num',
];

export const pkgExtLabels: string[] = [
    'expand_base_fee',
    'expand_user_num',
    'expand_channel_num',
    'expand_port_num',
];

export const pkgCompare: string[] = [
    'auto_reply_num',
    'ai_reply_num',
    'faq_num',
];
